import { render, staticRenderFns } from "./morbles.vue?vue&type=template&id=fc51e89c&"
import script from "./morbles.vue?vue&type=script&lang=js&"
export * from "./morbles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports